import { fetchReplenishmentRule } from '../utils/api';

export const REPLENISHMENT_RULE_FETCH = 'REPLENISHMENT_RULE_FETCH';
export const REPLENISHMENT_RULE_RECEIVED = 'REPLENISHMENT_RULE_RECEIVED';
export const REPLENISHMENT_RULE_ERROR = 'REPLENISHMENT_RULE_ERROR';
export const REPLENISHMENT_RULE_CLEAR_ERROR = 'REPLENISHMENT_RULE_CLEAR_ERROR';

export const fetchRule = (group, deviceCode) => async dispatch => {
  try {
    dispatch({
      type: REPLENISHMENT_RULE_FETCH,
    });

    const replenishmentRule = await fetchReplenishmentRule(group, deviceCode);
    const { productData, planogram, planogramImageUrl } = replenishmentRule;

    dispatch({
      type: REPLENISHMENT_RULE_RECEIVED,
      rule: productData ? productData : [],
      planogram: planogram,
      planogramImageUrl,
    });
  } catch (error) {
    dispatch({
      type: REPLENISHMENT_RULE_ERROR,
      error,
    });
  }
};

export const clearError = () => ({
  type: REPLENISHMENT_RULE_CLEAR_ERROR,
});
